export default {
  documentation: "Documentación",
  brandKit: "Kit de Marca",
  legalDisclaimer: "Aviso Legal",
}
